import { render, staticRenderFns } from "./TabS.vue?vue&type=template&id=6c19b472&scoped=true&"
import script from "./TabS.vue?vue&type=script&lang=js&"
export * from "./TabS.vue?vue&type=script&lang=js&"
import style0 from "./TabS.vue?vue&type=style&index=0&id=6c19b472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19b472",
  null
  
)

export default component.exports